import ReactModal from 'react-modal';
import Conexion from '../../Conexion/Conexion';
const {apiUrl} = Conexion();


const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: '40%',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
    },
  };
  
async function eliminarEvento(id) {
    return fetch(`${apiUrl}/api/eventos/${id}`, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': sessionStorage.getItem('token')
        }
    })
    .then(result => result.json())
}

export default function EventoEliminar(props){

    const datos = props.data;
    
    const closeModal=()=>{
        props.close();
    }

    let handleSubmit = async (e) =>{
        e.preventDefault();
        const eliminar = await eliminarEvento(datos.id);
        if(eliminar==="Eliminado con éxito"){
            alert("Eliminado con éxito");
            props.submit();
            props.close();
        }else{
            alert("Error");
        }
    }


    
    return (
        <div>
          <ReactModal
             isOpen={props.open}
             contentLabel="Eliminar Evento"
             htmlOpenClassName="col-md-6"
             style={customStyles}
          >
            
            <div className="container">
                <h2 className="text-center">Eliminar Evento</h2>
                <form className="col-lg-8 mx-auto mb-2" onSubmit={handleSubmit}>
                    <div className="mb-3">
                        <h3 className="text-center">Esta seguro?</h3>
                    </div>
                    <div className='text-center'>
                        <button type="submit" className="btn btn-primary text-right">Eliminar</button>
                        <button className="btn btn-danger" onClick={closeModal}>Cerrar</button>
                    </div>
                    
                </form>
                

            </div>
          </ReactModal>
        </div>
      );  

}